"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateLabelText = void 0;
const getDateLabelText = (label, t = (translationKey) => translationKey) => {
    var _a, _b, _c, _d;
    if (!label) {
        return '';
    }
    if (typeof window === 'undefined' ||
        !((_b = (_a = window === null || window === void 0 ? void 0 : window.I18n) === null || _a === void 0 ? void 0 : _a.t) === null || _b === void 0 ? void 0 : _b.call(_a, 'date.formats.date_picker'))) {
        return `${label} (${t('date.formats.date_picker')})`;
    }
    return `${label} (${(_d = (_c = window === null || window === void 0 ? void 0 : window.I18n) === null || _c === void 0 ? void 0 : _c.t) === null || _d === void 0 ? void 0 : _d.call(_c, 'date.formats.date_picker')})`;
};
exports.getDateLabelText = getDateLabelText;
//# sourceMappingURL=index.js.map